import { Box, SxProps } from "@mui/material";

import Text from "../Text/Text";

interface Props {
  text: string;
  isActive?: boolean;
  className?: string;
  sx?: SxProps;
  icon?: JSX.Element;
}

const Chip = ({ text, isActive, className, sx, icon }: Props) => {
  return (
    <Box className={`Chip ${isActive ? "isChipActive" : ""} ${className ?? ""}`} sx={sx}>
      { icon }
      <Text children={text} />
    </Box>
  );
};

export default Chip;